import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import AtRiskDashboard from "@/pages/AtRiskDashboard";
import DogsDirectory from "@/pages/DogsDirectory";
import DogProfile from "@/pages/DogProfile";
import RescuesDirectory from "@/pages/RescuesDirectory";
import SheltersDirectory from "@/pages/SheltersDirectory";
import ServicesDirectory from "@/pages/ServicesDirectory";
import AIMatchmaking from "@/pages/AIMatchmaking";
import FosterPortal from "@/pages/FosterPortal";
import VolunteerPortal from "@/pages/VolunteerPortal";
import PartnerPortal from "@/pages/PartnerPortal";
import CommunityFeed from "@/pages/CommunityFeed";
import DonationPage from "@/pages/DonationPage";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Transport from "@/pages/Transport";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AlertsPage from "@/pages/AlertsPage";
import CorporatePage from "@/pages/CorporatePage";
import StripeSetup from "@/pages/StripeSetup";
import RobotSnacks from "@/pages/RobotSnacks";
import OwnerStatus from "@/pages/OwnerStatus";
import ResourcesForRescues from "@/pages/ResourcesForRescues";
import WaysToGive from "@/pages/WaysToGive";
import PetFood from "@/pages/PetFood";
import JoinRescue from "@/pages/JoinRescue";
import ApiDocs from "@/pages/ApiDocs";
import RescuePortal from "@/pages/RescuePortal";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors />
                        <Header />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/at-risk" element={<AtRiskDashboard />} />
                                <Route path="/dogs" element={<DogsDirectory />} />
                                <Route path="/dogs/:id" element={<DogProfile />} />
                                <Route path="/rescues" element={<RescuesDirectory />} />
                                <Route path="/shelters" element={<SheltersDirectory />} />
                                <Route path="/services" element={<ServicesDirectory />} />
                                <Route path="/transport" element={<Transport />} />
                                <Route path="/matchmaking" element={<AIMatchmaking />} />
                                <Route path="/foster" element={<FosterPortal />} />
                                <Route path="/volunteer" element={<VolunteerPortal />} />
                                <Route path="/partner" element={<PartnerPortal />} />
                                <Route path="/community" element={<CommunityFeed />} />
                                <Route path="/donate" element={<DonationPage />} />
                                <Route path="/corporate" element={<CorporatePage />} />
                                <Route path="/stripe-setup" element={<StripeSetup />} />
                                <Route path="/alerts" element={<AlertsPage />} />
                                <Route path="/robot-snacks" element={<RobotSnacks />} />
                                <Route path="/resources" element={<ResourcesForRescues />} />
                                <Route path="/ways-to-give" element={<WaysToGive />} />
                                <Route path="/pet-food" element={<PetFood />} />
                                <Route path="/join" element={<JoinRescue />} />
                                <Route path="/api-docs" element={<ApiDocs />} />
                                <Route path="/developers" element={<ApiDocs />} />
                                <Route path="/rescue-portal" element={<RescuePortal />} />
                                <Route path="/owner/status" element={<OwnerStatus />} />
                                <Route path="/payment/success" element={<PaymentSuccess />} />
                                <Route path="/payment/cancel" element={<PaymentCancel />} />
                                <Route path="/auth" element={<Auth />} />
                                <Route path="/dashboard" element={<Dashboard />} />
                            </Routes>
                        </main>
                        <Footer />
                    </BrowserRouter>
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
